import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page42',
  templateUrl: './page42.component.html',
  styleUrls: ['./page42.component.css']
})
export class Page42Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
